import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const UnauthenticatedPageContentPanel = ({ className, title, subtitle, children }) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.header}>
        {title && (
          <CustomTypography
            className={styles.title}
            variant={TYPOGRAPHY_VARIANT.h1}
          >
            {title}
          </CustomTypography>
        )}
        {subtitle && (
          <CustomTypography
            className={styles.subtitle}
            variant={TYPOGRAPHY_VARIANT.paragraph16}
            dangerouslySetInnerHTML={{
              __html: subtitle,
            }}
          />
        )}
      </div>

      {children}
    </div>
  );
};
UnauthenticatedPageContentPanel.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
};

UnauthenticatedPageContentPanel.defaultProps = {
  className: null,
  title: null,
  subtitle: null,
  children: null,
};
